/*
Author: Jeewantha Karunarathna
Date: 11/12/2024
Copyright © 2024 Infix!. All rights reserved.
*/
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ITriageState {
    triageList: any
}

const initialState: ITriageState = {
    triageList: {},
}

const patientSurveySlice = createSlice({
    name: 'triageList',
    initialState,
    reducers: {
        triageDataFromDB: (
            state,
            action: PayloadAction<{
                data: any
            }>
        ) => {
            const { data } = action.payload
            state.triageList = data
        },
    },
})

export const { triageDataFromDB } = patientSurveySlice.actions


export default patientSurveySlice.reducer
